module.exports = __webpack_public_path__ + "fonts/Sparkasse_web_Rg.1e97dfaf.woff";